import React, {useCallback} from 'react';
import {ChooseDropdown, DropdownSelectTrigger} from '@priority-software/priority-style-react';
import {ruleDialogID} from '../../../../constants';
import {AutomationChoose} from '../../../../reducer/model';
import {isRTL} from '../../../../../../Localization';
import {texts} from '../../../../texts';

type SupportedValueTypes = string | number;

type Props = {
    options: Array<AutomationChoose>;
    onChange?: (option: AutomationChoose, name: string) => void;
    onMultiChange?: (values: Array<string | number>, name: string) => void;
    name: string;
    defaultValue: SupportedValueTypes | Array<SupportedValueTypes>;
    isDisabled?: boolean;
    menuIsOpen?: boolean;
    menuScrollMaxHeight?: number;
    isMulti?: boolean;
    placeholder?: string;
    componentClasses?: string;
    hideValue?: boolean;
    hasSearch?: boolean;
    openingSide?: 'rightSide' | 'leftSide';
    clearable?: boolean;
    clearValue?: (name: string) => void;
};

export const SelectControl = (props: Props) => {
    const {
        name,
        options,
        onChange,
        onMultiChange,
        defaultValue,
        isDisabled,
        menuScrollMaxHeight,
        componentClasses,
        placeholder = texts.select_placeholder,
        isMulti,
        hideValue,
        hasSearch,
        openingSide,
        clearable,
        clearValue
    } = props;

    const handleChange = useCallback(
        (option: AutomationChoose, isSelected: boolean) => {
            if (isMulti && Array.isArray(defaultValue)) {
                const data = isSelected
                    ? [...defaultValue, option.value]
                    : defaultValue.filter(val => val !== option.value);

                onMultiChange && onMultiChange(data as Array<SupportedValueTypes>, name);
            } else {
                onChange && onChange(option, name);
            }
        },
        [name, defaultValue, isMulti, onChange, onMultiChange]
    );

    const onClearValue = useCallback(() => {
        clearValue && clearValue(name);
    }, [name, clearValue]);

    return (
        <ChooseDropdown
            usePortal
            isRtl={isRTL()}
            hasSearch={hasSearch !== undefined ? hasSearch : options.length > 6}
            data={options}
            value={defaultValue}
            onChange={handleChange}
            trigger={
                <DropdownSelectTrigger
                    clearable={clearable}
                    onClearValue={clearable ? onClearValue : undefined}
                    hideValue={hideValue}
                    placeholder={placeholder}
                />
            }
            portalSelector={ruleDialogID}
            searchPlaceholder={texts.search_placeholder}
            noOptionsText={texts.no_options_text}
            disabled={isDisabled}
            maxScrollHeight={menuScrollMaxHeight}
            isMulti={isMulti}
            componentClasses={componentClasses}
            openingSide={openingSide}
        />
    );
};
